export enum FlexBoxDirection {
  /**
   * Items are placed top to bottom.<br />
   * <b>Note:</b> Corresponds to `column`.
   */
  Column = 'Column',
  /**
   * Items are placed bottom to top.<br />
   * <b>Note:</b> Corresponds to `column-reverse`.
   */
  ColumnReverse = 'ColumnReverse',
  /**
   * Items are placed left to right in `ltr` and right to left in `rtl`.<br />
   * <b>Note:</b> Corresponds to `row`.
   */
  Row = 'Row',
  /**
   * Items are placed right to left in `ltr` and left to right in `rtl`.<br />
   * <b>Note:</b> Corresponds to `row-reverse`.
   */
  RowReverse = 'RowReverse'
}
